import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

type PredefinedCommentPreviewDropdownProps = {
  options: { name: string; position?: number }[];
  resetKey?: string;
};

export function PredefinedCommentPreviewDropdown({
  options,
  resetKey,
}: PredefinedCommentPreviewDropdownProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(false);
  }, [resetKey]);

  const sortedOptions = [...options].sort(
    (a, b) => (a.position ?? 0) - (b.position ?? 0),
  );

  return (
    <div
      className={`predefined-comment-preview-dropdown${
        isOpen ? " is-open" : ""
      }`}
    >
      <button
        type="button"
        className="predefined-comment-preview-select"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        <span className="predefined-comment-preview-placeholder">
          {t("pleaseSelect")}
        </span>
        {isOpen ? (
          <KeyboardArrowUp className="predefined-comment-preview-chevron" />
        ) : (
          <KeyboardArrowDown className="predefined-comment-preview-chevron" />
        )}
      </button>
      {isOpen && !!sortedOptions.length && (
        <ul className="predefined-comment-preview-options">
          {sortedOptions.map((option, optionIndex) => (
            <li key={optionIndex}>{option.name}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
